import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { Button, Link } from "gatsby-theme-material-ui";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Colors } from "@theme/colors";
import { consoleSignupURL, addUrlParams } from "@src/urls";

const RegisterCTA = () => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const signupUrl = addUrlParams(consoleSignupURL);

  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: "1332px",
        margin: "0 auto",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          padding: { xs: "24px", md: "48px 56px", lg: "48px 112px" },
          background: Colors.PrimaryContrast,
          boxShadow: { xs: "none", md: Colors.mainShadow },
          borderRadius: { xs: "0", md: "24px" },
          zIndex: "2",
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          textAlign="left"
          justifyContent="left"
          spacing={3}
          sx={{
            position: "relative",
            zIndex: "2",
          }}
        >
          <Stack
            alignItems="flex-start"
            sx={{
              width: { xs: "100%", md: "50%" },
              textAlign: "left",
            }}
          >
            <Typography variant="h2" mb="16px">
              Try Pangea for Free
            </Typography>
            <Typography
              variant="body1"
              sx={{
                maxWidth: "540px",
                paddingRight: { sx: "0", md: "60px" },
              }}
            >
              Pangea's APIs are easy to integrate and free to start with. Sign
              up today and add security to your app!
            </Typography>
          </Stack>

          <Stack
            justifyContent="center"
            alignItems={{ xs: "left", md: "center" }}
            sx={{
              width: { xs: "100%", md: "50%" },
            }}
          >
            <Link
              href={signupUrl}
              target="pangea_console"
              underline="none"
              sx={{ minWidth: "30px" }}
            >
              <Button
                disableRipple
                disableElevation
                variant="contained"
                sx={{
                  color: Colors.PrimaryContrast,
                  margin: { xs: "0 auto", md: "inherit" },
                  minWidth: "300px",
                }}
              >
                Start Free
              </Button>
            </Link>
          </Stack>
        </Stack>
      </Box>
      {!isSmall && (
        <Box
          sx={{
            position: "absolute",
            left: "-150px",
            top: "-70px",
            zIndex: "1",
          }}
        >
          <img
            src={"/backgrounds/land5.svg"}
            loading="lazy"
            alt="background landmass"
          />
        </Box>
      )}
    </Stack>
  );
};

export default RegisterCTA;
